import React from "react";
import { Box } from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import SectionHeader from "../../common/SectionHeader";
import HorizontalCardContainer from "../../common/HorizontalCardContainer";
import { default as FinSpaceCard } from "../../common/Card/Card";
import ReportAnalysisCard from "../ReportAnalysisCard";
import Badge from "../../common/Badge";
import { AgenticFlowCardSkeleton } from "../CardSkeletons";
import { getWorkflowDisplayName } from "../../../constants/workflow-tags";

// Constants
const VIEW_ACTION_LABEL = "View";

interface AgenticFlowSectionProps {
  reportTypes: Array<{
    workflowName: string;
    workflowDescription: string;
    workflowShortName: string;
    disabled?: boolean;
    workflowActions: Array<{
      label: string;
      variant: "primary" | "secondary";
      icon?: string;
      route: string;
      onClick?: () => void;
      loading?: boolean;
    }>;
  }>;
  loading?: boolean;
  skeletonCount?: number;
}

const AgenticFlowSection: React.FC<AgenticFlowSectionProps> = ({
  reportTypes,
  loading = true,
  skeletonCount = 2,
}) => {
  return (
    <Box>
      <SectionHeader
        title="Agentic Flow"
        variant="h2"
        icon={<Icon name="gen-ai" />}
        useGradient={true}
        titleBadge={<Badge variant="status" color="blue" size="small">New</Badge>}
      />
      {loading ? (
        <div style={{ marginTop: "-8px" }} role="status" aria-label="Loading workflows">
          <HorizontalCardContainer ariaLabel="Featured cards horizontal scroll">
            {Array.from({ length: skeletonCount }, (_, i) => (
              <AgenticFlowCardSkeleton key={i} />
            ))}
          </HorizontalCardContainer>
        </div>
      ) : (
        <div style={{ marginTop: "-8px" }}>
          <HorizontalCardContainer ariaLabel="Featured cards horizontal scroll">
            {reportTypes.map((type, index) => {
              // Find the View action to get its route
              const viewAction = type.workflowActions.find(action => action.label === VIEW_ACTION_LABEL);
              const viewRoute = viewAction?.route;
              
              return (
                <FinSpaceCard 
                  key={index} 
                  disabled={type.disabled}
                  href={viewRoute}
                >
                  <ReportAnalysisCard
                    title={type.workflowName}
                    description={type.workflowDescription}
                    avatar={{
                      type: "initials",
                      content: getWorkflowDisplayName(type.workflowShortName),
                      variant: "primary",
                    }}
                    actions={type.workflowActions}
                  />
                </FinSpaceCard>
              );
            })}
          </HorizontalCardContainer>
        </div>
      )}
    </Box>
  );
};

export default AgenticFlowSection;
